/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetDriversQueryResponse, GetDriversQueryParams, GetDrivers400 } from '../entities/GetDrivers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getDrivers } from '../api/getDrivers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getDriversQueryKey = (params: GetDriversQueryParams) => [{ url: '/drivers' }, ...(params ? [params] : [])] as const

export type GetDriversQueryKey = ReturnType<typeof getDriversQueryKey>

export function getDriversQueryOptions(params: GetDriversQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getDriversQueryKey(params)
  return queryOptions<GetDriversQueryResponse, ResponseErrorConfig<GetDrivers400>, GetDriversQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getDrivers(params, config)
    },
  })
}

/**
 * @description Get drivers
 * @summary Get drivers
 * {@link /drivers}
 */
export function useGetDrivers<TData = GetDriversQueryResponse, TQueryData = GetDriversQueryResponse, TQueryKey extends QueryKey = GetDriversQueryKey>(
  params: GetDriversQueryParams,
  options: {
    query?: Partial<QueryObserverOptions<GetDriversQueryResponse, ResponseErrorConfig<GetDrivers400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getDriversQueryKey(params)

  const query = useQuery(
    {
      ...(getDriversQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetDrivers400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}